import { render, staticRenderFns } from "./sf6o3.vue?vue&type=template&id=1ffc05d2&scoped=true"
import script from "./sf6o3.vue?vue&type=script&lang=js"
export * from "./sf6o3.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=1ffc05d2&prod&scoped=true&lang=css&external"
import style1 from "./sf6o3.vue?vue&type=style&index=1&id=1ffc05d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc05d2",
  null
  
)

export default component.exports